import Vue from 'vue'
import ElementUI from 'element-ui';
import './theme/element-#5473E8/index.css';
import App from './App.vue'
import router from './router'
import store from './store'
import materialDesignIcons from './assets/fonts/css/materialdesignicons.css';

Vue.config.productionTip = false;
// Vue.prototype.Mock = require('mockjs');
Vue.use(ElementUI);
Vue.use(materialDesignIcons);

import {ChartAPI} from "./utils/chart";

ChartAPI.registerChartTheme();
ChartAPI.registerChartShape();
ChartAPI.setDefaultOptions();

new Vue({
    router,
    store,
    data() {
        return {
            layoutMode: 'aside'
        }
    },
    render: h => h(App)
}).$mount('#app')
